import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ManagementToolRoutingModule } from './management-tool-routing.module';
import { ManagementToolComponent } from './management-tool.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, ManagementToolRoutingModule, TranslateModule],
  declarations: [ManagementToolComponent],
})
export class ManagementToolModule {}
